import { Component, OnDestroy, NgZone, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common'; import { CartNuvemShopService } from 'src/app/services/cart-nuvem-shop.service';

import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag'; import { PlatformService } from 'src/app/services/platform.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { CartShopifyService } from 'src/app/services/cart-shopify.service';
import { PMetaStoreService } from 'src/app/services/p-meta-store.service';
@Component({
  selector: 'app-shopping-cart',
  standalone: true,
  imports: [CommonModule, ButtonModule, InputNumberModule, SkeletonModule, ToastModule, TagModule, FormsModule],
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
  providers: [

  ]
})
export class ShoppingCartComponent implements OnDestroy {
  cartItems$ = new BehaviorSubject<any[]>([]);
  private cartItemsSubscription!: Subscription;
  private cartUpdatedSubscription?: Subscription;
  private cartListenerAttached = false;
  private lastValidQuantities: { [key: string]: number } = {};
  subtotal = 0;
  total = 0;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private errorHandler: ErrorHandlerService,
    private messageService: MessageService,
    private nuvemCart: CartNuvemShopService,
    private cdr: ChangeDetectorRef,
    private platformService: PlatformService,
    private shopifyCartService: CartShopifyService,
    private zone: NgZone,
    private pMetaStore: PMetaStoreService
  ) { }
  private isRunningInsideNuvemshopStorefront(): boolean {
    const LS = (window as any).LS;
    return !!(LS?.store);
  }

  platform: string = "other";
  ngOnInit(): void {
    this.platform = this.platformService.identifyPlatform();


    this.loadCartItems('1');


    const isShopifyStorefront = this.platform === 'shopify' && this.isRunningInsideShopifyStorefront();
    if (!isShopifyStorefront) {
      this.zone.runOutsideAngular(() => {
        window.addEventListener('cartUpdated', this.handleCartUpdated);
        this.cartListenerAttached = true;
      });

      this.cartUpdatedSubscription = this.shoppingCartService.cartUpdated$.subscribe(() => {
        this.loadCartItems('2');
      });
    }

  }

  private handleCartUpdated = (_event: any) => {
    //this.zone.run(() => );
    this.loadCartItems('3')
  }
  loading: boolean = true;
  isUpdatingCart = false;

  loadCartItems(n: string): void {
    this.loading = true;

    const isShopifyStorefront = this.platform === 'shopify' && this.isRunningInsideShopifyStorefront();

    if (isShopifyStorefront) {
      if (this.cartItemsSubscription) {
        this.cartItemsSubscription.unsubscribe();
      }

      this.cartItemsSubscription = this.shoppingCartService.cartItems$.subscribe(items => {
        this.cartItems$.next([...items]);
        this.pruneTransientItemState(items);
        this.storeLastValidQuantities(items);
        this.calculateTotals(items);
        this.loading = false;
      });
      this.shopifyCartService.getCartDetails().subscribe({
        next: (response) => {
          this.shoppingCartService.syncShopifyCart(response.items, this.cartItems$.getValue());
        },
        error: (error) => {
          this.loading = false;
        }
      });
    } else {
      // fluxo local / other
      if (this.cartItemsSubscription) {
        this.cartItemsSubscription.unsubscribe();
      }

      this.cartItemsSubscription = this.shoppingCartService.cartItems$.subscribe(cartItems => {
        this.cartItems$.next(cartItems);
        this.pruneTransientItemState(cartItems);
        this.storeLastValidQuantities(cartItems);
        this.calculateTotals(cartItems);
        this.loading = false;
      });
    }
  }

  private isRunningInsideShopifyStorefront(): boolean {
    // heurística simples: Shopify costuma expor window.Shopify em storefront
    return typeof (window as any).Shopify !== 'undefined';
  }

  buyNow() {
    this.pMetaStore.sendBeginCheckoutEvent(this.cartItems$.getValue());

    // ✅ Shopify: só se estiver no storefront Shopify
    if (this.platform === 'shopify' && this.isRunningInsideShopifyStorefront()) {
      const checkoutUrl = this.shopifyCartService.getCheckoutUrl();
      this.clearLocalCartAndNotify();
      window.location.href = checkoutUrl;
      return;
    }

    // ✅ Nuvemshop: se estiver no storefront Nuvemshop, usa o redirect “real”
    if (this.platform === 'nuvemshop' && this.isRunningInsideNuvemshopStorefront()) {
      this.setCartUpdating(true);
      this.nuvemCart.redirectToCheckout();
      this.clearLocalCartAndNotify();
      return;
    }

    // ✅ fora de storefront → decide por plataforma
    if (this.platform === 'shopify') {
      this.redirectToShopifyCustomCheckout();
      return;
    }

    // ✅ fora de storefront:
    // - se plataforma for nuvemshop → seu fluxo externo (POST /comprar/ com return_to)
    if (this.platform === 'nuvemshop') {
      this.setCartUpdating(true);
      this.redirectToNuvemshopCheckoutOutside();
      return;
    }

    // ✅ local/other (se existir)
    this.redirectToLocalCheckout();
  }

  private clearLocalCartAndNotify(): void {
    try {
      localStorage.removeItem('ss_shopping_cart');
    } catch { }

    // mantém estado interno e observers coerentes
    this.shoppingCartService.clearCart();
  }
  // displayCommandMenu
  // private redirectToNuvemshopCheckoutOutside(): void {
  //   console.log('chamou redirectToNuvemshopCheckoutOutside')
  //   const storedCart = localStorage.getItem('ss_shopping_cart');
  //   const cartItems = storedCart ? JSON.parse(storedCart) : [];
  //   if (!cartItems.length) return;

  //   const storeRaw = localStorage.getItem('store');
  //   if (!storeRaw) return;

  //   let domain = '';
  //   try {
  //     const store = JSON.parse(storeRaw);
  //     domain = String(store.ss_cart_page || store.ss_nuvemshop_domain || '');
  //   } catch { return; }

  //   domain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');
  //   if (!domain) return;

  //   // monta "variant:qty,variant:qty"
  //   const pairs: string[] = [];
  //   for (const it of cartItems) {
  //     const variantId = Number(it.variant_id || it.id);
  //     const qty = Math.max(1, Number(it.quantity || 1));
  //     if (!variantId) continue;
  //     pairs.push(`${variantId}:${qty}`);
  //   }
  //   if (!pairs.length) return;

  //   const encoded = pairs.join(',');

  //   // ✅ tentativa 1: /cart/{encoded}
  //   const url1 = `https://${domain}/cart/${encoded}`;

  //   // ✅ tentativa 2 (fallback): /{encoded}
  //   const url2 = `https://${domain}/${encoded}`;


  //   console.log('url 1')
  //   console.log(url1)

  //   console.log('url 2')
  //   console.log(url2)

  //   // estratégia simples: tenta url1; se a loja não usa /cart/, você troca para url2 fixo.
  //   //window.location.href = url1;

  //   // se quiser forçar fallback automático (sem fetch), só dá pra fazer com “tentativa manual”:
  //   // -> você testa uma vez no browser qual funciona e fixa.
  // }

  private redirectToNuvemshopCheckoutOutside(): void { // isUpdatingCart
    const storedCart = localStorage.getItem('ss_shopping_cart');
    const cartItems = storedCart ? JSON.parse(storedCart) : [];
    if (!Array.isArray(cartItems) || !cartItems.length) return;

    // você já tem store_id salvo (SelectedStoreId / store)
    let storeId = Number(localStorage.getItem('ss_SelectedStoreId') || 0);
    if (!storeId) {
      const storeRaw = localStorage.getItem('store');
      try {
        const store = storeRaw ? JSON.parse(storeRaw) : null;
        storeId = Number(store?.SelectedStoreId || store?.id || 0);
      } catch { }
    }
    if (!storeId) return;
    this.isUpdatingCart = true;
    // monta payload só com o que a API precisa: variant_id + quantity
    const items = cartItems
      .map((it: any) => ({
        variant_id: Number(it.variant_id || it.id),
        quantity: Math.max(1, Number(it.quantity || 1)),
      }))
      .filter((x: any) => x.variant_id && x.quantity > 0);

    if (!items.length) return;

    this.nuvemCart.createCheckoutUrl(storeId, items).subscribe({
      next: (resp) => {
        const url = resp?.checkout_url || resp?.abandoned_checkout_url;
        if (url) {
          this.isUpdatingCart = false;
          this.clearLocalCartAndNotify();
          window.location.href = url;
        } else {
          this.setCartUpdating(false);
        }
      },
      error: (err) => {
        this.setCartUpdating(false);
        this.errorHandler.handle(err, 'Falha ao processar checkout.');
      }
    });
  }


  private postRedirect(actionUrl: string, fields: Record<string, string>) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  private redirectToLocalCheckout(): void {
    this.clearLocalCartAndNotify();
    window.location.href = '/checkout';
  }

  private redirectToShopifyCustomCheckout() {
    const storedCart = localStorage.getItem("ss_shopping_cart");
    const cartItems = storedCart ? JSON.parse(storedCart) : [];
    if (cartItems.length === 0) return;

    const storeData = localStorage.getItem("store");
    let baseUrl = "https://meusite.com";

    if (storeData) {
      try {
        const store = JSON.parse(storeData);
        if (store["ss_cart_page"]) {
          baseUrl = `https://${store["ss_cart_page"]}`;
        }
      } catch { }
    }

    const params = cartItems
      .map((item: any) =>
        `id=${encodeURIComponent(Number(this.extractShopifyProductId(item.variant_id || item.id)))}&quantity=${item.quantity}`
      )
      .join("&");

    const checkoutUrl = `${baseUrl}/cart/add?${params}&return_to=/checkout`;
    this.clearLocalCartAndNotify();
    window.location.href = checkoutUrl;
  }


  //////////////////////////////////////
  private getStoreRoutesFallback(domain: string) {
    // fallback quando NÃO existir window.LS
    // aqui você pode usar PT/ES baseado no que você salva no backend (language/country)
    // por enquanto, vou manter um fallback seguro:
    return {
      cartUrl: '/cart',      // você vai ajustar conforme seu caso (ex /carrinho)
      checkoutUrl: '/checkout'
    };
  }
  //////////////////////////////////////
  onQuantityChange(item: any, newQuantity: number): void {
    const key = this.getItemKey(item);
    delete this.cartErrors[key];
    const previousQuantity = this.lastValidQuantities[key] ?? item.quantity ?? 1;

    const estoqueTotalRaw = item.stock ?? item.inventory_quantity;
    const estoqueTotal = estoqueTotalRaw == null ? null : Number(estoqueTotalRaw);

    const clampAndNotify = (qty: number, message: string) => {
      item.quantity = qty;
      this.cartErrors[key] = message;
      this.lastValidQuantities[key] = qty;
      const currentItems = this.cartItems$.getValue();
      this.cartItems$.next([...currentItems]);
      this.cdr.detectChanges();
    };
    const revertToPrevious = (message: string) => {
      const fallbackQuantity = previousQuantity ?? 1;
      clampAndNotify(fallbackQuantity, message);
    };

    // Quantidade zerada via botão − remove o item do carrinho
    if (newQuantity < 1) {
      this.removeItem(item);
      return;
    }

    if (item.tracked) {
      // Quando não existe estoque confiável (comum no Shopify storefront),
      // não bloqueia a UI nem trava o checkout. A plataforma valida o estoque.
      const hasStockInfo =
        typeof estoqueTotal === 'number' &&
        !Number.isNaN(estoqueTotal) &&
        estoqueTotal > 0;

      if (hasStockInfo && newQuantity > estoqueTotal) {
        clampAndNotify(estoqueTotal, `Quantidade máxima disponível: ${estoqueTotal} unidade(s).`);
        return;
      }
    }

    item.quantity = newQuantity;

    this.updateQuantity(item, item.quantity, previousQuantity);
  }

  private setCartUpdating(value: boolean): void {
    this.zone.run(() => {
      this.isUpdatingCart = value;
      this.cdr.detectChanges();
    });
  }

  calculateTotals(cartItems: any[]) {
    this.subtotal = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
    this.total = this.subtotal;
  }

  updateQuantity(item: any, newQuantity: number, previousQuantity?: number) {
    this.setCartUpdating(true); 
    const key = this.getItemKey(item);

    if (this.platform === 'nuvemshop' && this.isRunningInsideNuvemshopStorefront()) {
      const lineItemId = this.getNuvemshopLineItemId(item);

      if (!lineItemId) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não encontrei o ID do item no carrinho da Nuvemshop (line_item_id).'
        });
        this.setCartUpdating(false);
        return;
      }

      this.setCartUpdating(true);

      this.nuvemCart.updateQuantityStorefront(lineItemId, Number(newQuantity))
        .pipe(
          // ✅ garante que o loading SEMPRE volta
          finalize(() => this.setCartUpdating(false))
        )
        .subscribe({
          next: (resp) => {
            const ok = resp.status >= 200 && resp.status < 400;
            if (!ok) {
              const msg = this.nuvemCart.humanizeNuvemshopError(resp?.body, 'Não foi possível atualizar a quantidade.');
              throw new Error(msg);
            }

            // ✅ se vier JSON, ótimo; se vier HTML, também ok
            const body = resp.body;

            // Se algum dia vier JSON com success=false
            if (body && typeof body === 'object' && body?.success === false) {
              const msg = this.nuvemCart.humanizeNuvemshopError(body, 'Não foi possível atualizar a quantidade.');
              throw new Error(msg);
            }

            // ✅ atualiza snapshot local
            this.shoppingCartService.updateCartItemQuantity(item.id, newQuantity);

            // ✅ toast sucesso
            this.messageService.add({
              severity: 'success',
              summary: 'Carrinho atualizado',
              detail: `Quantidade de "${item.name}" atualizada para ${newQuantity}.`
            });

            // opcional: recalcular totals imediatamente
            const updated = this.shoppingCartService.getCartItems();
            this.pruneTransientItemState(updated);
            this.calculateTotals(updated);
            this.storeLastValidQuantities(updated);
            this.cartItems$.next([...updated]);
          },

          error: (err) => {
            // reverte UI
            if (previousQuantity != null) {
              item.quantity = previousQuantity;
              this.shoppingCartService.updateCartItemQuantity(item.id, previousQuantity);
              this.cdr.detectChanges();
            }

            const msg = this.nuvemCart.humanizeNuvemshopError(err, 'Não foi possível atualizar a quantidade na Nuvemshop.');

            this.messageService.add({
              severity: 'error',
              summary: 'Falha ao atualizar',
              detail: msg
            });

            this.errorHandler.handle(err, msg);
          }
        });

      return; // ✅ não cai no fluxo local
    }


    if (this.platform === 'shopify' && this.isRunningInsideShopifyStorefront()) {
      const itemKey = item.key;
      if (!itemKey) {
        console.error('? Erro: key n?o encontrada no item:', item);
        this.setCartUpdating(false);
        return;
      }

      this.shopifyCartService.updateCartItemQuantity(itemKey, newQuantity).subscribe({
        next: (response) => {

          this.shoppingCartService.syncShopifyCart(response.items, this.cartItems$.getValue());
          const updatedItems = this.shoppingCartService.getCartItems();
          this.cartItems$.next([...updatedItems]);
          this.storeLastValidQuantities(updatedItems);
          this.calculateTotals(updatedItems);
          this.messageService.add({
            severity: 'success',
            summary: 'Produto Atualizado',
            detail: 'O item "' + item.name + '" foi atualizado com sucesso para "' + newQuantity + '"!'
          });
          this.emitAddToCartIfNeeded(item, previousQuantity, newQuantity);
          this.setCartUpdating(false);
        },
        error: (error) => {
          let errorMessage = 'Ocorreu um erro ao atualizar o produto.';

          try {
            const errorBody = error.error || {};
            if (errorBody.message) {
              errorMessage = errorBody.message;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          } catch (e) {
            console.error('? Erro ao processar mensagem de erro:', e);
          }
          if (previousQuantity != null) {
            item.quantity = previousQuantity;
            this.lastValidQuantities[key] = previousQuantity;
            const currentItems = this.cartItems$.getValue();
            this.cartItems$.next([...currentItems]);
            this.cdr.detectChanges();
          }
          this.messageService.add({
            severity: 'warn',
            summary: 'N?o foi poss?vel atualizar',
            detail: errorMessage
          });


          this.errorHandler.handle(error, errorMessage);
          this.setCartUpdating(false);
        }

      });

    } else {

      const success = this.shoppingCartService.updateCartItemQuantity(item.id, newQuantity);
      this.setCartUpdating(false);
      if (success) {
        this.storeLastValidQuantities(this.cartItems$.getValue());
        this.messageService.add({
          severity: 'success',
          summary: 'Produto Atualizado',
          detail: 'O item "' + item.name + '" foi atualizado para "' + newQuantity + '" unidades.'
        });
        this.emitAddToCartIfNeeded(item, previousQuantity, newQuantity);
      } else {
        if (previousQuantity != null) {
          item.quantity = previousQuantity;
          this.lastValidQuantities[this.getItemKey(item)] = previousQuantity;
          const currentItems = this.cartItems$.getValue();
          this.cartItems$.next([...currentItems]);
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao Atualizar',
          detail: 'N?o foi poss?vel atualizar a quantidade do produto.'
        });

      }

    }

  }

  private getNuvemshopLineItemId(item: any): number | null {
    const direct = Number(item?.line_item_id);
    if (direct) return direct;

    const variantId = Number(item?.variant_id || item?.id);
    if (!variantId) return null;

    try {
      const raw = localStorage.getItem('ss_nuvemshop_line_item_map');
      const map = raw ? JSON.parse(raw) : {};
      const lineId = Number(map[String(variantId)]);
      return lineId || null;
    } catch {
      return null;
    }
  }

  private getDisplayName(item: any): string {
    const base = (item?.name_without_variants || item?.name || '').trim();
    const variant = (item?.variant || item?.variant_title || '').trim();
    return variant ? `${base} - ${variant}` : base;
  }

  private extractShopifyProductId(graphQLId: string): string {
    const match = graphQLId.match(/(\d+)$/); // 🔥 Extrai apenas os números finais do ID
    return match ? match[1] : graphQLId; // Se encontrar, retorna apenas o número
  }

  trackViewCart(): void {
    const items = this.cartItems$.getValue();
    console.log('[cart] trackViewCart chamado — itens:', items);
    if (!items?.length) {
      console.log('[cart] trackViewCart — carrinho vazio, view_cart não disparado');
      return;
    }
    this.pMetaStore.sendViewCartEvent(items);
  }

  removeItem(item: any) {
    console.log('[cart] removeItem clicado — item:', item);
    this.pMetaStore.sendRemoveFromCartEvent(item);
    const isShopifyStorefront = this.platform === 'shopify' && this.isRunningInsideShopifyStorefront();
    const transientKey = this.getItemKey(item);
    delete this.cartErrors[transientKey];
    delete this.lastValidQuantities[transientKey];

    if (isShopifyStorefront) {
      const itemKey = item.key;

      if (!itemKey) {
        console.error('❌ Erro: `key` não encontrada no item:', item);
        return;
      }

      this.shopifyCartService.removeFromCart(itemKey).subscribe({
        next: (response) => {
          this.shoppingCartService.syncShopifyCart(response.items, this.cartItems$.getValue());
          const updatedItems = this.shoppingCartService.getCartItems();
          this.cartItems$.next([...updatedItems]);
          this.pruneTransientItemState(updatedItems);
          this.storeLastValidQuantities(updatedItems);
          this.calculateTotals(updatedItems);
          this.shoppingCartService.refreshCartState();

          this.messageService.add({
            severity: 'success',
            summary: 'Produto Removido',
            detail: `O item "${item.name}" foi removido com sucesso!`
          });

        },
        error: (error) => {
          let errorMessage = 'Ocorreu um erro ao adicionar o produto.';
          try {
            const errorBody = error.error || {};
            if (errorBody.message) {
              errorMessage = errorBody.message;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          } catch (e) {
            console.error('❌ Erro ao processar mensagem de erro:', e);
          }
          this.errorHandler.handle(error, errorMessage);
        }
      });
    } else if (this.platform === 'nuvemshop' && this.isRunningInsideNuvemshopStorefront()) {
      const lineItemId = this.getNuvemshopLineItemId(item);

      if (!lineItemId) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não encontrei o ID do item no carrinho da Nuvemshop (line_item_id).'
        });
        return;
      }

      this.setCartUpdating(true);

      this.nuvemCart.removeItemStorefront(lineItemId)
        .pipe(finalize(() => this.setCartUpdating(false)))
        .subscribe({
          next: (resp: any) => {

            console.log('dentro do remove item')
            console.log(resp)

            const ok = resp.status >= 200 && resp.status < 400;
            if (!ok) {
              const msg = this.nuvemCart.humanizeNuvemshopError(resp?.body, 'Não foi possível remover o item.');
              throw new Error(msg);
            }

            const body = resp.body;
            console.log(body)
            // ✅ 1) se vier JSON e der erro explícito
            if (body && typeof body === 'object' && body?.success === false) {
              throw new Error(
                this.nuvemCart.humanizeNuvemshopError(body, 'Não foi possível remover o item.')
              );
            }

            // ✅ 2) mesmo se success=true, valida se o item SUMIU do carrinho real
            const stillThere = (body?.cart?.products || [])
              .some((p: any) => Number(p?.id) === Number(lineItemId));

            if (stillThere) {
              throw new Error('A Nuvemshop respondeu sucesso, mas o item ainda está no carrinho. Tente novamente.');
            }

            // ✅ remove do snapshot local (só depois de confirmar que removeu no real)
            this.shoppingCartService.removeFromCart(item.id);

            this.messageService.add({
              severity: 'success',
              summary: 'Produto removido',
              detail: `O item "${this.getDisplayName(item)}" foi removido do carrinho.`
            });

            const updated = this.shoppingCartService.getCartItems();
            this.calculateTotals(updated);
            this.storeLastValidQuantities(updated);
            this.cartItems$.next([...updated]);

            this.shoppingCartService.refreshCartState();
          },

          error: (err: any) => {
            const msg = this.nuvemCart.humanizeNuvemshopError(err, 'Não foi possível remover o item na Nuvemshop.');

            this.messageService.add({
              severity: 'error',
              summary: 'Falha ao remover',
              detail: msg
            });

            this.errorHandler.handle(err, msg);
          }
        });


      return;
    } else {
      const success = this.shoppingCartService.removeFromCart(item.id);
      if (success) {
        this.shoppingCartService.refreshCartState();
        const updatedItems = this.shoppingCartService.getCartItems();
        this.pruneTransientItemState(updatedItems);
        this.messageService.add({
          severity: 'success',
          summary: 'Produto Removido',
          detail: `O item "${item.name}" foi removido do carrinho.`
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao Remover',
          detail: 'Não foi possível remover o produto do carrinho.'
        });
      }
    }
  }

  persistArtifactsFromBody(body: any) {
    const cart = body?.cart;
    if (!cart) return;

    if (cart?.id) localStorage.setItem('ss_nuvemshop_cart_id', String(cart.id));
    if (cart?.token) localStorage.setItem('ss_nuvemshop_cart_token', String(cart.token));
    if (cart?.abandoned_checkout_url) localStorage.setItem('ss_nuvemshop_abandoned_checkout_url', String(cart.abandoned_checkout_url));

    const map: Record<string, number> = {};
    (cart?.products || []).forEach((p: any) => {
      if (p?.variant_id && p?.id) map[String(p.variant_id)] = Number(p.id);
    });

    if (Object.keys(map).length) {
      localStorage.setItem('ss_nuvemshop_line_item_map', JSON.stringify(map));
    }
  }


  // ✅ Encerra a Subscription ao destruir o componente
  ngOnDestroy(): void {
    if (this.cartListenerAttached) {
      window.removeEventListener('cartUpdated', this.handleCartUpdated);
    }
    this.cartUpdatedSubscription?.unsubscribe();
    if (this.cartItemsSubscription) {
      this.cartItemsSubscription.unsubscribe();
    }
  }

  // map de erros por item
  cartErrors: { [key: string]: string } = {};

  getItemKey(item: any): string {
    return String(item.variant_id || item.id || item.key);
  }

  hasBlockingErrors(): boolean {
    return Object.keys(this.cartErrors).length > 0;
  }

  private pruneTransientItemState(items: any[]): void {
    const keys = new Set((items || []).map(it => this.getItemKey(it)));

    Object.keys(this.cartErrors).forEach((k) => {
      if (!keys.has(k)) {
        delete this.cartErrors[k];
      }
    });

    Object.keys(this.lastValidQuantities).forEach((k) => {
      if (!keys.has(k)) {
        delete this.lastValidQuantities[k];
      }
    });
  }

  private storeLastValidQuantities(items: any[]): void {
    (items || []).forEach(item => {
      const key = this.getItemKey(item);
      if (key) {
        this.lastValidQuantities[key] = item.quantity ?? 1;
      }
    });
  }

  stepQuantity(item: any, delta: number): void {
    const current = item.quantity ?? 0;
    const next = current + delta;
    this.onQuantityChange(item, next);
  }

  preventManualInput(event: KeyboardEvent): void {
    const allowedKeys = ['Tab', 'Shift', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    event.preventDefault();
  }

  private emitAddToCartIfNeeded(item: any, previousQuantity?: number, newQuantity?: number): void {
    if (previousQuantity == null || newQuantity == null) {
      return;
    }
    const added = newQuantity - previousQuantity;
    if (added > 0) {
      const detail = this.buildCartAddEventDetail(item, added);
      window.dispatchEvent(new CustomEvent('customEvents', { detail }));
    }
  }

  private buildCartAddEventDetail(item: any, qty: number) {
    const variant = item?.variant ?? '';
    return {
      event: 'ss_add_to_cart',
      sku: item?.variant_id ?? item?.id ?? '',
      title: item?.name ?? '',
      ...(variant ? { variant } : {}),
      category: this.resolveItemCategory(item),
      qty,
      price: Number(item?.price ?? 0)
    };
  }

  private resolveItemCategory(item: any): string | string[] {
    const categories = item?.categories;
    if (Array.isArray(categories) && categories.length) {
      return categories.length === 1 ? categories[0] : categories;
    }
    if (typeof categories === 'string') {
      return categories;
    }
    return item?.category ?? '';
  }
}
